import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments';

export interface ExpiredProduct {
  id: number;
  name: string;
  expirationDate: string;
  initialDate: string;
  visitProductId: number;
}

export interface VisitTotalProductsUsedModel {
  name?: string;
  amount?: number;
  unit?: string;
  details: VisitTotalProductsUsedAreaMonitorItemModel[];
}

export interface VisitTotalProductsUsedAreaMonitorItemModel {
  areaName?: string;
  monitorNumber?: string;
  amount?: number;
}

export interface VisitSummaryScoreMobileModel {
  scoreStatus?: number | null;
  visitSummary?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class VisitDayDetailsService {
  constructor(private http: HttpClient) {}

  public getExpiredProducts(visitId: string): Observable<ExpiredProduct[]> {
    return this.http.get<ExpiredProduct[]>(
      `${environment.apiHost}/mobile/visit/expired-products`,
      { params: { visitId } }
    );
  }

  public getTotalProductsUsed(
    visitId: string
  ): Observable<VisitTotalProductsUsedModel[]> {
    return this.http.get<VisitTotalProductsUsedModel[]>(
      `${environment.apiHost}/mobile/visit/total-products-used`,
      { params: { visitId } }
    );
  }

  public checkIPMQuestionnaireFilled(visitId: string): Observable<boolean> {
    return this.http.get<boolean>(
      `${environment.apiHost}/mobile/questionnaire-check`,
      { params: { visitId } }
    );
  }

  public getOrCreateVisitChat(visitId: string): Observable<{ chatId: string }> {
    return this.http.post<{ chatId: string }>(
      `${environment.apiHost}/mobile/v1.0/visit-chats/${visitId}`,
      {}
    );
  }

  public getVisitSummaryScore(
    visitId: string
  ): Observable<VisitSummaryScoreMobileModel> {
    return this.http.get<VisitSummaryScoreMobileModel>(
      `${environment.apiHost}/mobile/visit/summary-score`,
      { params: { visitId } }
    );
  }
}
